import BaseApi from '../../base/base'

export interface AIInlineEditRequest {
  prompt: string
  selectedText: string
  promptId?: number
  context?: string
}

export interface AIInlineEditResponse {
  content: string
  success: boolean
  error?: string
}

/**
 * API for AI Inline Edit feature
 * Uses RubyLLM with gpt-4o directly (no Langchain service needed)
 */
export default class AIInlineEditApi extends BaseApi {
  constructor() {
    super()
  }

  /**
   * Kick off AI inline edit job
   * Response is streamed via ActionCable (ChatExamGenerationChannel)
   */
  async generate(examId: number, params: AIInlineEditRequest): Promise<AIInlineEditResponse> {
    this.path = `/admin/exams/${examId}/ai_inline_edits`

    const requestBody = {
      prompt: params.prompt,
      selected_text: params.selectedText,
      prompt_id: params.promptId
    }

    try {
      await this.postRequest(requestBody)
      // Backend returns {} immediately, response comes via ActionCable
      return { content: '', success: true }
    } catch (error: any) {
      console.error('AI Inline Edit API error:', error)
      return {
        content: '',
        success: false,
        error: error.message || 'Failed to start AI generation'
      }
    }
  }
}
